var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19961 15.0002H6.64961V9.9502H5.19961V15.0002ZM13.3746 15.0002H14.7996V4.6002H13.3746V15.0002ZM9.29961 15.0002H10.7246V12.1002H9.29961V15.0002ZM9.29961 9.9502H10.7246V8.5002H9.29961V9.9502ZM2.59961 19.0252C2.16628 19.0252 1.78711 18.8627 1.46211 18.5377C1.13711 18.2127 0.974609 17.8335 0.974609 17.4002V2.6002C0.974609 2.1502 1.13711 1.7627 1.46211 1.4377C1.78711 1.1127 2.16628 0.950195 2.59961 0.950195H17.3996C17.8496 0.950195 18.2371 1.1127 18.5621 1.4377C18.8871 1.7627 19.0496 2.1502 19.0496 2.6002V17.4002C19.0496 17.8335 18.8871 18.2127 18.5621 18.5377C18.2371 18.8627 17.8496 19.0252 17.3996 19.0252H2.59961ZM2.59961 17.4002H17.3996V2.6002H2.59961V17.4002ZM2.59961 2.6002V17.4002V2.6002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.86d18cce7bb06b43831d1da54ebce9fe.svg";
export { ForwardRef as ReactComponent };